import React from 'react'
import PropTypes from 'prop-types'

export default class Pluralize extends React.Component {
  static propTypes = {
    singular: PropTypes.string.isRequired,
    plural: PropTypes.string,
    count: PropTypes.number,
    showCount: PropTypes.bool,
  }

  static defaultProps = {
    count: 1,
    showCount: true,
    plural: null,
  }

  render() {
    let text = ''
    const { singular, count, showCount } = this.props
    let { plural } = this.props

    // if not specified then use standard plural ending
    if (!plural) {
      plural = `${singular}s`
    }

    // set correct ending to text
    text = count === 1 ? singular : plural
    if (showCount) {
      text = `${String(count)} ${text}`
    }

    return text
  }
}
